import {
  Stack,
  Text,
  Icon,
  Badge,
  Link,
  Panel,
  PanelHeader,
  PanelTitle,
  PanelSection,
  InlineStack,
  SkeletonText,
} from '@customerio/pluma-components/react';
import type { ServicesApiEnvHealthSegmentStats } from '@/services/api/services-api';

export function SegmentsPanel({
  segments,
  isLoading,
  workspaceId,
}: {
  segments?: ServicesApiEnvHealthSegmentStats;
  isLoading: boolean;
  workspaceId: number;
}) {
  const segmentsPath = `/workspaces/${workspaceId}/journeys/segments`;
  return (
    <Panel>
      <PanelHeader>
        <PanelTitle text="product-h4" color="subtle">
          <InlineStack gap="050" alignBlock="center">
            <Icon name="segment" size="sm" color="bold" />
            Segments
          </InlineStack>
        </PanelTitle>
      </PanelHeader>
      <PanelSection>
        {isLoading ? (
          <SkeletonText size="s" lines={3} />
        ) : segments != null ? (
          <Stack gap="100">
            <InlineStack alignInline="space-between" alignBlock="center" py="050">
              <Link variant="secondary" href={segmentsPath}>
                <Text size="s">Total</Text>
              </Link>
              <Badge>{segments.total_count.toLocaleString()}</Badge>
            </InlineStack>
            <InlineStack alignInline="space-between" alignBlock="center" py="050">
              <Link variant="secondary" href={`${segmentsPath}?usage=not_in_use`}>
                <Text size="s">Unused</Text>
              </Link>
              <Badge>{segments.unused_count.toLocaleString()}</Badge>
            </InlineStack>
            <InlineStack alignInline="space-between" alignBlock="center" py="050">
              <Link variant="secondary" href={`${segmentsPath}?usage=in_sent_newsletters`}>
                <Text size="s">Newsletter only</Text>
              </Link>
              <Badge>{segments.newsletter_only_count.toLocaleString()}</Badge>
            </InlineStack>
          </Stack>
        ) : null}
      </PanelSection>
      {segments != null && (segments.unused_count > 0 || segments.newsletter_only_count > 0) ? (
        <PanelSection>
          <Text size="xs" color="subtle">
            When profile data changes, segments relevant to that profile are re-evaluated — even unused ones. Removing
            unused segments and archiving newsletter-only ones reduces unnecessary processing and helps your workspace
            run faster.
          </Text>
        </PanelSection>
      ) : null}
    </Panel>
  );
}
